export default __webpack_public_path__ + "static/media/Inventory-Set-green-box.1985f9de.svg";